import React, { useEffect } from "react";
import { useDrag } from "react-dnd";
import { getEmptyImage } from "react-dnd-html5-backend";

import styles from "./PaletteItem.css";

const PaletteItem = ({ children, itemType, elementCreator, onPaletteDropEnd }) => {
	const [ , drag, preview ] = useDrag({
		item: {
			type: itemType,
			isNew: true,
			row: -1,
			col: -1,
			item: {},
			latestPlaceholder: null
		},
		begin () {
			const item = elementCreator();

			return {
				type: itemType,
				row: -1,
				col: -1,
				isNew: true,
				item,
				latestPlaceholder: null,
				id: item.id
			};
		},
		end () {
			if (onPaletteDropEnd) {
				onPaletteDropEnd();
			}
		}
	});
	useEffect(
		() => {
			preview(getEmptyImage(), { captureDraggingState: true });
		},
		[
			preview
		]
	);

	return (
		<div ref={drag} className={styles.item}>{children}</div>
	);
};

export default PaletteItem;
